import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axios, axiosInstance } from "../axios";
import type { ISocialOfferWithFavoriteChallenges } from "./types";

export const useGetSocialOffer = () => {
  const [state, execute, cancel] = axios<ISocialOfferWithFavoriteChallenges>(
    {
      method: "get",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (id: string) => {
      return execute({
        url: `/v2/offers/social/${id}`,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};

export const useGetSocialOfferSuspense = (id: ObjectId) => {
  return useSuspense(() => axiosInstance.get<ISocialOfferWithFavoriteChallenges>(`/v2/offers/social/${id}`), [id]);
};
